var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg_index"},[_c('div',{staticClass:"w100 cpfa"}),_vm._v(" "),_c('div',{staticClass:"sound-meeting"}),_vm._v(" "),_c('cooperateForm',{staticClass:"submitform",attrs:{"id":"submit"}}),_vm._v(" "),_c('div',{staticClass:"footblack"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6e5cb8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/solution/Hs/SoundMeeting.vue
// module id = null
// module chunks = 